export const getIsPricelessLot = (auctionId: number, lotNumber: number): boolean => {
  if(auctionId === 4091 && lotNumber === 1) {
    return true;
  }
  return false;
};
